/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '@/lib/kubb-client';
import type {
  RequestConfig,
  ResponseConfig,
  ResponseErrorConfig,
} from '@/lib/kubb-client';
import type { UseMutationOptions, QueryClient } from '@tanstack/react-query';
import type {
  PostApiAuthLogoutMutationResponse,
  PostApiAuthLogout401,
  PostApiAuthLogout500,
} from '../types/PostApiAuthLogout.ts';
import { useMutation } from '@tanstack/react-query';

export const postApiAuthLogoutMutationKey = () =>
  [{ url: '/api/auth/logout' }] as const;

export type PostApiAuthLogoutMutationKey = ReturnType<
  typeof postApiAuthLogoutMutationKey
>;

/**
 * @description Remove the JWT token from Redis to log out
 * @summary User Logout
 * {@link /api/auth/logout}
 */
export async function postApiAuthLogout(
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    PostApiAuthLogoutMutationResponse,
    ResponseErrorConfig<PostApiAuthLogout401 | PostApiAuthLogout500>,
    unknown
  >({
    method: 'POST',
    url: `/api/auth/logout`,
    ...requestConfig,
  });
  return res;
}

/**
 * @description Remove the JWT token from Redis to log out
 * @summary User Logout
 * {@link /api/auth/logout}
 */
export function usePostApiAuthLogout<TContext>(
  options: {
    mutation?: UseMutationOptions<
      ResponseConfig<PostApiAuthLogoutMutationResponse>,
      ResponseErrorConfig<PostApiAuthLogout401 | PostApiAuthLogout500>,
      void,
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ?? postApiAuthLogoutMutationKey();

  return useMutation<
    ResponseConfig<PostApiAuthLogoutMutationResponse>,
    ResponseErrorConfig<PostApiAuthLogout401 | PostApiAuthLogout500>,
    void,
    TContext
  >(
    {
      mutationFn: async () => {
        return postApiAuthLogout(config);
      },
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  );
}
